export default __webpack_public_path__ + "static/2-8d711bed0912d049733971aabf6d1327.jpeg";